import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILocationCapacity } from '@api/types'
import { LocationCapacityFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      capacityLocations: ILocationCapacity[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, ILocationCapacity[]>({
  handler: (data) => data.viewer.company.capacityLocations,
  name: 'Capacity Location',
})

function fetch(): Promise<ILocationCapacity[]> {
  return client.gql.query({ query: capacityLocationsQuery }).then(mutateHandler)
}

const capacityLocationsQuery = gql`
  query locations {
    viewer {
      company {
        capacityLocations {
          ...LocationCapacityFragment
        }
      }
    }
  }
  ${LocationCapacityFragment}
`

interface MutationInput {
  capacity: number
  locationIds: string[]
}

// will want to reload after adding
function add(input: MutationInput) {
  return client.gql.mutate({ mutation: addMutation, variables: { input } })
}

const addMutation = gql`
  mutation addLocationsCapacity($input: AddCapacityToLocationsInput!) {
    addCapacityToLocations(input: $input) {
      locations {
        id
      }
    }
  }
`

// will want to reload after updating
function update(input: MutationInput) {
  return client.gql.mutate({ mutation: updateMutation, variables: { input } })
}

const updateMutation = gql`
  mutation updateLocationsCapacity($input: UpdateLocationsCapacityInput!) {
    updateLocationsCapacity(input: $input) {
      locations {
        id
      }
    }
  }
`

// will want to reload after removing
function remove(input: { locationIds: string[] }) {
  return client.gql.mutate({ mutation: removeMutation, variables: { input } })
}

const removeMutation = gql`
  mutation removeLocationsCapacity($input: DeleteLocationsCapacityInput!) {
    deleteLocationsCapacity(input: $input) {
      locations {
        id
      }
    }
  }
`

export default { fetch, add, update, remove }
